export default __webpack_public_path__ + "static/media/arrow.03d1e529.svg";